import { h, } from "preact";
import { useState, useEffect, } from "preact/hooks";
import SortableGridItem from "./SortableGridItem";
//import { createPortal, forwardRef, render } from 'preact/compat';
import { Box } from "@mui/material";

import {
    closestCenter,
    DndContext,
    DragOverlay,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";

import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,

} from "@dnd-kit/sortable";
import { Grid } from "@mui/material";

// 

const SortableGridContainer = (props) => {
    //console.log("render SortableGridContainer")
    const [activeId, setActiveId] = useState(null);
    const [items, setItems] = useState(props.items);
    //const [touch, setTouch] = useState(0);
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    function handleDragStart(event) {
        const { active } = event;
        //  console.log("start item", active);
        //    console.log("start", active.id);

        setActiveId(active.id);
    }

    function handleDragEnd(event) {
        const { active, over } = event;
        // console.log("end", active.id, over.id);

        if (active && over && active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.findIndex((it) => it.uid === active?.id);
                const newIndex = items.findIndex((it) => it.uid === over?.id);
                // console.log("indexes", oldIndex, newIndex);

                return arrayMove(items, oldIndex, newIndex);
            });

        }
        setActiveId(null);

    }

    useEffect(() => {

        //console.log("items changed", items);
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({ uid: props.uid, pics: items }),
        };

        fetch("/api/2a21b208edd4433ab6ec43b164eca697", requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        //reset
                        //setTouch(touch + 1);
                        props.updateItems(items.map((rec, i) => { var rec0 = rec; rec0.rn = i + 1; return rec0 }));
                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });

    }, [items]);

    return (

        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            onDragStart={handleDragStart}

        >
            <SortableContext items={items} strategy={verticalListSortingStrategy}>

                <Box display="flex" flexWrap="wrap" justifyContent={"flex-start"}>
                    {items.map((it, index) => {
                        // console.log("map items", index)
                        return (
                            <SortableGridItem
                                setUpperActiveStep0={props.setUpperActiveStep0}

                                key={index}
                                id={it.uid}
                                idx={index}
                                item={it}


                            />
                        );
                    })}
                </Box>
            </SortableContext>

            {activeId && items.findIndex((it) => it.uid === activeId)}
            <DragOverlay>{activeId ? <SortableGridItem key={items.findIndex((it) => it.uid === activeId)} setUpperActiveStep0={props.setUpperActiveStep0} id={activeId} item={items[items.findIndex((it) => it.uid === activeId)]} /> : null}</DragOverlay>
        </DndContext>
    );
};

export default SortableGridContainer;